import type { CSSProperties } from 'react'
import './pare-loading.css'

export type PareLoadingProps = {
  variant?: 'section' | 'fullscreen' | 'inline'
  label?: string
  description?: string
  className?: string
  style?: CSSProperties
}

/** Render only while work is pending. Fullscreen is a page surface, not a modal. */
export function PareLoading({
  variant = 'section',
  label = 'กำลังเตรียมข้อมูลร้านยา',
  description = 'อีกสักครู่ก็พร้อมใช้งาน',
  className = '',
  style,
}: PareLoadingProps) {
  return (
    <div
      className={`pare-loading pare-loading--${variant} ${className}`.trim()}
      style={style}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      {variant === 'inline' ? (
        <div className="pare-mini" aria-hidden="true" />
      ) : (
        <div className="pare-motion" aria-hidden="true">
          <div className="pare-halo" />
          <span className="pare-spark spark-one" />
          <span className="pare-spark spark-two" />
          <div className="pare-pill">
            <div className="pare-half" />
            <div className="pare-shine" />
          </div>
          <div className="pare-shadow" />
        </div>
      )}
      <span className="pare-heading">{label}</span>
      {variant !== 'inline' && (
        <>
          {description && <span className="pare-caption">{description}</span>}
          <div className="pare-dots" aria-hidden="true">
            <span />
            <span />
            <span />
          </div>
        </>
      )}
    </div>
  )
}
